import { render, staticRenderFns } from "./OrganisationOverview.vue?vue&type=template&id=53350e7a&scoped=true"
import script from "./OrganisationOverview.vue?vue&type=script&lang=js"
export * from "./OrganisationOverview.vue?vue&type=script&lang=js"
import style0 from "./OrganisationOverview.vue?vue&type=style&index=0&id=53350e7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53350e7a",
  null
  
)

export default component.exports